import { LogoMark } from "./Logo";
import { CONTACT } from "./data";

export const Footer = () => (
  <footer data-testid="site-footer" className="relative border-t border-gold/20 bg-obsidian-2 overflow-hidden">
    <div className="max-w-[1400px] mx-auto px-5 sm:px-8 pt-16 pb-8">
      <div className="flex flex-col sm:flex-row justify-between gap-6 text-ivory/70 text-sm">
        <LogoMark className="h-16" />
        <p className="font-mono text-[11px] uppercase tracking-[0.2em] sm:text-right">{CONTACT.address} · {CONTACT.city}<br />{CONTACT.phone} · {CONTACT.email}</p>
      </div>
      <div className="mt-8 flex flex-col sm:flex-row justify-between gap-2 font-mono text-[11px] uppercase tracking-[0.2em] text-ivory/50">
        <span>© {new Date().getFullYear()} Hair Boutique</span>
        <span>P.IVA 04090040926</span>
      </div>
    </div>
  </footer>
);
